module.exports = __webpack_public_path__ + "img/LogoExos_Gris.b40e6daa.png";